import BudgetPage from "./BudgetPage";

export default [
    {
        path: "/budget",
        name: "budget",
        component: BudgetPage
    }
];